import { Type } from './action-types';
import { CanvaAction, CanvaState, canvaStateFactory } from './types';

const defaultState = canvaStateFactory();

export default function(state: CanvaState = defaultState, action: CanvaAction) {
  switch (action.type) {
    case Type.CANVA_AUTHORIZE_SUCCESS: {
      return state.merge(action.payload);
    }

    case Type.CANVA_USER_CLEAR:
      return canvaStateFactory();

    case Type.CREATE_CANVA_DESIGN_REQUEST: {
      return state
        .set('isCreatingDesign', true)
        .set('isDesignInProgress', true);
    }

    case Type.CREATE_CANVA_DESIGN_SUCCESS: {
      return state.set('isCreatingDesign', false);
    }

    case Type.CREATE_CANVA_DESIGN_FAILURE: {
      return state
        .set('isCreatingDesign', false)
        .set('isDesignInProgress', false);
    }

    case Type.EXPORT_CANVA_DESIGN_REQUEST: {
      return state.set('isExportingDesign', true);
    }

    case Type.EXPORT_CANVA_DESIGN_SUCCESS: {
      return state.set('isExportingDesign', false);
    }

    case Type.EXPORT_CANVA_DESIGN_FAILURE: {
      return state
        .set('isDesignInProgress', false)
        .set('isExportingDesign', false);
    }

    case Type.CLEAR_CANVA_DESIGN_IN_PROGRESS: {
      return state.set('isDesignInProgress', false);
    }

    default:
      return state;
  }
}
